import variationsFor from './variationsFor'

const types = {
  SAVE_PAST_TRANSACTIONS_FILTERS: 'SAVE_PAST_TRANSACTIONS_FILTERS',
  ...variationsFor('GET_PAST_TRANSACTIONS'),
  ...variationsFor('GET_FUTURE_TRANSACTIONS')
}

export default types
